/* Mengenstaffel-UI (Protect24 Club, Eigenbau) — Fortschrittsbalken + €-Spar-Hinweis.
   Nachgebaut aus der eigenen Logik von assets/snocks-quantity-breaks.js (bisheriges
   Theme), angepasst auf die neuen Klassennamen des quantity-tiers-Snippets. */
(function () {
  'use strict';

  function setupContainer(container) {
    if (container.dataset.qtInit === 'true') return;
    container.dataset.qtInit = 'true';

    const discountPercent = parseFloat(container.dataset.discountPercent) || 0;
    const basePrice = parseFloat(container.dataset.basePrice) || 0;
    const radios = container.querySelectorAll('input[type="radio"]');
    if (!radios.length) return;

    const header = document.createElement('div');
    header.className = 'quantity-tiers__header';
    header.innerHTML = 'Menge: <strong>1</strong>';
    container.insertBefore(header, container.firstChild);

    const progress = document.createElement('div');
    progress.className = 'quantity-tiers__progress';
    const progressBar = document.createElement('div');
    progressBar.className = 'quantity-tiers__progress-bar';
    progress.appendChild(progressBar);
    container.insertBefore(progress, container.firstChild.nextSibling);

    function updateUI(activeIdx) {
      const total = radios.length;
      const radio = radios[activeIdx];
      const qty = radio ? (parseInt(radio.value, 10) || (activeIdx + 1)) : 1;

      const strong = header.querySelector('strong');
      if (strong) strong.textContent = qty;

      progressBar.style.width = (((activeIdx + 1) / total) * 100) + '%';
    }

    radios.forEach((radio, idx) => {
      radio.addEventListener('change', () => {
        if (radio.checked) updateUI(idx);
      });
    });

    const checkedIdx = Array.from(radios).findIndex((r) => r.checked);
    updateUI(checkedIdx >= 0 ? checkedIdx : 0);
  }

  function init() {
    document.querySelectorAll('quantity-tiers').forEach(setupContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
